<div class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="errorMessage != ''">
    <strong>{{errorMessage}}</strong>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
</div>

<mat-card>
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="submit()">
        <h2>Regisztrálás</h2>
        <mat-form-field class="full-width-input">
          <input matInput placeholder="Felhasználónév" formControlName="username" required>
        </mat-form-field>
        <mat-form-field class="full-width-input">
          <input matInput type="password" placeholder="Jelszó" formControlName="password" required>
        </mat-form-field>
        <mat-form-field class="full-width-input">
            <input matInput type="password" placeholder="Jelszó újra" formControlName="RePassword" required>
          </mat-form-field>
        <button mat-raised-button color="primary" >Regisztrálás</button>
        <div class="divider"></div>
        <button mat-raised-button color="primary" routerLink="/calendar" >Vissza</button>
      </form>
    </mat-card-content>
  </mat-card>